import {ApolloClient, from, fromPromise, InMemoryCache} from "@apollo/client"
import {setContext} from '@apollo/client/link/context';
import Config from '../../config/config';
import {createUploadLink} from "apollo-upload-client";
import {onError} from "@apollo/client/link/error";
import {Auth} from 'aws-amplify';
import * as actions from "../actions"

const getNewToken = async () => {
  try {
    const currentSession: any = await Auth.currentSession();
    const cognitoUser = await Auth.currentAuthenticatedUser();
    return new Promise((resolve) =>
      cognitoUser.refreshSession(currentSession.refreshToken, async (err: any, session: any) => {
        if (err) {
          actions.logoutUserSuccess();
          localStorage.clear();
          await Auth.signOut();
          await cognitoUser.signOut();
          window.location.replace("/user/login")
        } else {
          const {idToken, accessToken} = session;
          localStorage.setItem("auth_token", accessToken['jwtToken']);
          localStorage.setItem("idToken", idToken['jwtToken']);
          resolve({
            newAccessToken: accessToken['jwtToken'],
            newIdToken: idToken['jwtToken']
          });
        }
      }));
  } catch (e) {
    localStorage.clear();
    window.location.replace("/user/login");
  }
};

const errorLink = onError(
  ({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors) {
      for (const err of graphQLErrors) {
        if (err.extensions?.code === 'UNAUTHENTICATED') {
          actions.logoutUserSuccess();
          localStorage.clear();
          window.location.replace("/user/login")
        }
        if (err.extensions?.code === 401) {
          return fromPromise(
            getNewToken().catch(async () => {
              const cognitoUser = await Auth.currentAuthenticatedUser();
              actions.logoutUserSuccess();
              localStorage.clear();
              await Auth.signOut();
              await cognitoUser.signOut();
              window.location.replace("/user/login");
              return;
            })
          )
            .filter((value) => Boolean(value))
            .flatMap((res: any) => {
              const oldHeaders = operation.getContext().headers;
              // modify the operation context with a new token
              operation.setContext({
                headers: {
                  ...oldHeaders,
                  accesstoken: res.newAccessToken,
                  idToken: res.newIdToken
                },
              });

              // retry the request, returning the new observable
              return forward(operation);
            });
        }
        // if (err.extensions?.code === 'INTERNAL_SERVER_ERROR') {
        //   window.location.replace("/404");
        // }
      }
    }
    if (networkError) {
      // put the logic for the network error handling
    }
  }
);

const clientLink:any = createUploadLink({
  uri: Config.API_URL
});

const authLink = setContext((_, { headers }) => {
  const auth_token = localStorage.getItem("auth_token") ? localStorage.getItem("auth_token") : "";
  const idToken = localStorage.getItem("idToken") ? localStorage.getItem("idToken") : "";
  const ipAddress = localStorage.getItem("ipAddress") ? localStorage.getItem("ipAddress") : "";

  // return the headers to the context so httpLink can read them
  const user_data = JSON.parse(localStorage.getItem("user_data") || "{}");
  return {
    headers: {
      ...headers,
      accesstoken: auth_token ? auth_token : "",
      schemaname: (user_data && user_data.customer_name) ? user_data.customer_name : "",
      idToken: idToken ? idToken : "",
      ipAddress: ipAddress ? ipAddress : ""
    }
  }
});

const client = new ApolloClient({
  link: from([errorLink, authLink, clientLink]),
  cache: new InMemoryCache()
});

const initialState = {
  client: client,
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default reducer
